export default customElements.define('w-fancy-button', class FancyButton extends wealthify.CustomElementBaseClass {

    constructor() {
        const config = {
            styleSelector: 'c-fancy-button',
            templateHTML: `
                <button class="c-fancy-button" type="button" data-root>
                    <div class="c-fancy-button__main" data-main>
                        <div class="c-fancy-button__label" data-label></div>
                    </div>
                    <div class="c-fancy-button__description">
                        <div class="c-fancy-button__title u-display__none" data-title></div>
                        <div data-child-root></div>
                    </div>
                </button>`,
            hasChildren: true,
            cacheDom: ['data-main', 'data-label', 'data-title' ]
        };

        super(config);

        this.onConnectedCallback = () => {
            this.addEventListener('click', () => {
                if (this.onclickprop) {
                    this.onclickprop();
                }
            });
        };
    }

    static get validShapes () {
        return ['diamond', 'diamondsmall', 'rectangle', 'border'];
    }

    static get validStates () {
        return ['complete', 'selected', 'unselected'];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('label', {required: true}),
            new wealthify.Prop('onclickprop', {type: wealthify.propTypes.Function()}),
            new wealthify.Prop('shape', {
                type: wealthify.propTypes.ArrayItem(this.validShapes),
                default: 'diamond'
            }),
            new wealthify.Prop('state', {
                type: wealthify.propTypes.ArrayItem(this.validStates),
                default: 'unselected'
            }),
            new wealthify.Prop('titleprop'),
            new wealthify.Prop('first', {
                type: wealthify.propTypes.Boolean(),
                default: false
            }),
            new wealthify.Prop('last', {
                type: wealthify.propTypes.Boolean(),
                default: false
            }),
            // TODO - Remove disabledprop when ariadisabled is used in all occurences (e.g. w-progress-bar)
            // disabledprop used to proxy aria-disabled functionality.
            new wealthify.Prop('disabledprop', {type: wealthify.propTypes.Boolean()}),
            wealthify.props.AriaHidden(),
            wealthify.props.AriaDisabled()
        ];
    }

    get propCallbacks() {
        return {
            label: (value) => {
                this.validateLabelForShape();
                this.dom.label.innerHTML = value;
            },
            onclickprop: (value) => this.dom.root.onclick = value,
            shape: (value) => {
                this.validateLabelForShape();

                this.constructor.validShapes.forEach((shape) => {
                    this.dom.root.classList.remove(`${this.styleSelector}--shape-${shape}`);
                    this.dom.main.classList.remove(`${this.styleSelector}__main--shape-${shape}`);
                    this.dom.label.classList.remove(`${this.styleSelector}__label--shape-${shape}`);
                });
                
                this.dom.root.classList.add(`${this.styleSelector}--shape-${value}`);
                this.dom.main.classList.add(`${this.styleSelector}__main--shape-${value}`);
                this.dom.label.classList.add(`${this.styleSelector}__label--shape-${value}`);

            },
            state: (value) => {
                this.constructor.validStates.forEach((state) => {
                    this.dom.root.classList.remove(`${this.styleSelector}--state-${state}`);
                    this.dom.title.classList.remove(`${this.styleSelector}__title--state-${state}`);
                });
                
                if(!this.ariadisabled) {
                    this.dom.root.classList.add(`${this.styleSelector}--state-${value}`);
                    this.dom.title.classList.add(`${this.styleSelector}__title--state-${value}`);
                }
            },
            titleprop: (value) => {
                const classListAction = value ? 'remove' : 'add';

                this.dom.title.classList[classListAction]('u-display__none');
                this.dom.title.innerHTML = value;
            },
            first: () => { 
                const classListAction = this.first ? 'add' : 'remove';

                this.dom.main.classList[classListAction](`${this.styleSelector}__main--shape-${this.shape}-first`);
            },
            last: () => { 
                const classListAction = this.last ? 'add' : 'remove';

                this.dom.main.classList[classListAction](`${this.styleSelector}__main--shape-${this.shape}-last`);
            },
            // TODO - Remove when ariadisabled is used in all occurences (e.g. w-progress-bar)
            // Currently proxying disabledprop usages to work as ariadisabled.
            disabledprop: () =>  this.ariaDisabled = this.disabledprop
        };
    }

    validateLabelForShape () {
        if (!this.label || !this.shape) {
            return;
        }

        const labelTooLarge = this.shape === 'diamond' && this.label.length >= 15;

        if (labelTooLarge) {
            wealthify.error.throwError(this.tagName, `Label's length of ${this.label.length} too long for shape.`);
        }
    }
});